import React, {FC} from "react";

export const DevelopmentInProgress: FC = () => (
    <div style={{
        padding: "20px",
        textAlign: "center",
    }}>
        <h1>Development in progress...</h1>
        <p>We're working to bring this section</p>
    </div>
);


